var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.714 8.038a.743.743 0 00-.22-.528.782.782 0 00-1.088-.008l-7.692 7.406-7.692-7.406a.781.781 0 00-1.087.008.74.74 0 00.008 1.063l8.232 7.926c.3.287.779.287 1.078 0l8.232-7.926a.741.741 0 00.23-.535"
  })));
};
export default SvgDown;